import { orderBy, where } from "firebase/firestore";
import { Form } from "react-bootstrap";
import { useParams } from "react-router";

import {
    useAreasDocument,
    useTaskCollection,
} from "../../api/firestoreWrappers.generated";
import { isTaskValid } from "../../pages/TaskListPage";
import { naturalSort } from "../../utils/sortingUtils";

export default function TaskSelector(props) {
    const { organizationId, locationId } = useParams();
    const [tasks] = useTaskCollection(organizationId, locationId, [
        where("deleted", "==", false),
        orderBy("name", "asc"),
    ]);
    const [areasDoc] = useAreasDocument(organizationId, locationId);

    return (
        <Form.Select
            value={props.value || "none"}
            onChange={(event) => props.onChange(event.target.value)}
        >
            <option disabled value="none">
                Select a task ...
            </option>
            {tasks
                .sort((a, b) => naturalSort(a.name, b.name))
                .map((task) => {
                    return (
                        <option
                            key={task.id}
                            value={task.id}
                            disabled={!isTaskValid(task, areasDoc)}
                        >
                            {task.name}
                            {!isTaskValid(task, areasDoc) &&
                                " (This task is invalid)"}
                        </option>
                    );
                })}
        </Form.Select>
    );
}
